import { useCallback, useMemo, useState } from 'react';
import context from './context';

const { Provider } = context;

type Props = {
  defaultKeywords?: string[];
  fallbackKeywords?: string[];
};
const HelpProvider: FC<Props> = ({ defaultKeywords, fallbackKeywords, children }) => {
  const [keywordsStack, setKeywordsStack] = useState<string[][]>(
    defaultKeywords ? [defaultKeywords] : [],
  );
  const setKeywords = useCallback(
    (keywords: string[]) => setKeywordsStack((prev) => [...prev, keywords]),
    [],
  );
  const unsetKeywords = useCallback(
    (keywords: string[]) => setKeywordsStack((prev) => prev.filter((kw) => kw !== keywords)),
    [],
  );
  const keywords = useMemo(() => {
    const result = ([] as string[]).concat(...keywordsStack);
    return result.length || !fallbackKeywords ? result : fallbackKeywords;
  }, [fallbackKeywords, keywordsStack]);

  return (
    <Provider value={{ keywords, keywordsStack, setKeywords, unsetKeywords }}>{children}</Provider>
  );
};

export default HelpProvider;
